import { useCallback } from 'react';
import { WebSocketManager } from '../../components/websocket';
import { WS_ENDPOINTS } from '../../components/websocket';
import { MessageHeader, RequestID } from '@/api/spec.ts';

export function useMarketWebSocketSender() {
  const sendMessage = useCallback(<T extends MessageHeader>(message: T): RequestID | undefined => {
    const manager = WebSocketManager.getInstance();
    return manager.sendMessage(WS_ENDPOINTS.MARKET_DATA, message);
  }, []);

  return { sendMessage };
}
